<template>
  <base-modal
    :close-button-visible="false"
    overlay-id="modalLevels"
  >
    <div :class="['banner', levelInfo.imageCssClass]">
      <base-image
        :src="$_getTranslations.logo_for_branded_projects || '/static/images/logos/logo_white.svg'"
        image-class="lvl_up_logo"
        alt="LOGO"
        fallback-src="/static/images/logos/logo_white.svg"
      ></base-image>
    </div>
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_level_up_title_pt1 }}<br><b>{{ levelInfo.title }}</b></h1>

      <p>{{ levelInfo.description }}</p>

      <div class="gift_points_box">
        <div class="header">{{ $_getTranslations.home_modals_level_up_gift_points }}</div>

        <div class="flex-row">
          <p class="points">+{{ levelInfo.rewardPoints }} {{ $_getTranslations.home_modals_level_up_points }}</p>
          <img src="/static/images/home/points_star.png">
        </div>
      </div>

      <base-button container-class="play" button-class="fancy_btn close_modal">
        {{ $_getTranslations.home_modals_level_up_continue_button }}
      </base-button>

      <base-button container-class="blue" @button:click="$emit('redirect:levelsPage')">
        {{ $_getTranslations.home_modals_level_up_levels_page_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapState} from 'vuex'
import {Howl} from 'howler'
import BaseModal from '../../common/modal/BaseModal'
import BaseImage from '../../common/image/BaseImage.vue';
import BaseButton from '../../common/button/BaseButton'
import translationMixin from '../../../common/mixins/translation'
import {isNumber, isObject} from '../../../helpers/common'
import {levelUpModalInfo} from '../../../constants/level'
import {achievementLevelNamePerLevelNumber} from '../../../constants/achievement'

export default {
  name: 'LevelUp',
  components: {
    BaseModal,
    BaseImage,
    BaseButton
  },
  mixins: [translationMixin],
  emits: ['redirect:levelsPage'],
  props: {
    level: {
      type: Number,
      default: 0
    },
    rewardPoints: {
      type: Number,
      default: 0
    },
    playSound: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      modalSound: new Howl({src: ['/static/sounds/levelup.mp3']})
    }
  },
  created () {
    if (this.playSound && localStorage.getItem('soundsOn') === 'true') {
      this.modalSound.play()
    }
  },
  computed: {
    ...mapState('profile', [
      'achievements'
    ]),
    levelInfo () {
      const info = levelUpModalInfo[this.level]

      let rewardPoints = 0
      if (isNumber(this.rewardPoints) && this.rewardPoints > 0) {
        rewardPoints = this.rewardPoints
      } else {
        const levelAchievement = Array.isArray(this.achievements) && isObject(this.achievements[0]) && Array.isArray(this.achievements[0].achievementDTOs) && achievementLevelNamePerLevelNumber.hasOwnProperty(this.level)
          ? this.achievements[0].achievementDTOs.find(({achievementName}) => achievementName === achievementLevelNamePerLevelNumber[this.level])
          : null

        if (levelAchievement && Array.isArray(levelAchievement.achievementLevelDTOs) && isObject(levelAchievement.achievementLevelDTOs[0])) {
          rewardPoints = levelAchievement.achievementLevelDTOs[0].prizeValue
        }
      }

      return {
        ...(info
            ? {imageCssClass: info.imageCssClass, title: this.$_translateText({key: info.title}), description: this.$_translateText({key: info.description})}
            : {imageCssClass: '', title: '', description: ''}
        ),
        rewardPoints: rewardPoints || 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/LevelUp.vue